import { motion } from 'framer-motion';

export default function SkillBadges({ skills }) {
  return (
    <div className="skill-badges">
      {skills.map((s, i) => (
        <motion.span
          key={s}
          className="skill-badge"
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.04, duration: 0.4 }}
        >
          {s}
        </motion.span>
      ))}
    </div>
  );
}
